import { MainLayoutSimple } from "components/layouts/MainLayoutSimple";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import OtherProfile from "../page/OtherProfile";

const routes: AppRouteType[] = [
  {
    path: slugs.otherProfile,
    component: OtherProfile,
    container: MainLayoutSimple,
    isAuthNeeded: true,
  },
];

export default routes;
